<script lang="ts">
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CareerStudentBanners.translations.json";
	import careerImageMotivation from "../assets/images/career-students-banner-1.jpg?webp&w=1920&imagetools";
	import careerImageHighSchool from "../assets/images/career-students-banner-2.jpg?webp&w=1920&imagetools";
	import careerImageUniversity from "../assets/images/career-students-banner-3.jpg?webp&w=1920&imagetools";
	import CareerBanner from "./CareerBanner.svelte";
	import { scrollSmootherStore } from "../stores/scrollSmootherStore.js";

	const translate = getTranslate(translations, true);

	function toCareerForm(): void {
		window.location.replace(`#career-form`);
		$scrollSmootherStore?.scrollTo("#career-form", true, "top top");
	}

	/* eslint-disable svelte/no-at-html-tags */
</script>

<CareerBanner title={translate("motivationHeadline")} image={careerImageMotivation} on:click={toCareerForm}>
	<div slot="content">
		<p class="mt-6 px-4 text-base font-light min-[425px]:text-[1.125rem] lg:px-0">
			{@html translate("motivationPerex")}
		</p>
	</div>
	<svelte:fragment slot="button">
		{@html translate("motivationLinkText")}
	</svelte:fragment>
</CareerBanner>
<CareerBanner title={translate("highSchoolHeadline")} image={careerImageHighSchool} on:click={toCareerForm}>
	<div slot="content">
		<p class="mt-6 px-4 text-base font-light min-[425px]:text-[1.125rem] lg:px-0">
			{@html translate("highSchoolPerex")}
		</p>
	</div>
	<svelte:fragment slot="button">
		{@html translate("highSchoolLinkText")}
	</svelte:fragment>
</CareerBanner>
<CareerBanner title={translate("universityHeadline")} image={careerImageUniversity} on:click={toCareerForm}>
	<div slot="content">
		<p class="mt-6 px-4 text-base font-light min-[425px]:text-[1.125rem] lg:px-0">
			{@html translate("universityPerex")}
		</p>
	</div>
	<svelte:fragment slot="button">
		{@html translate("universityLinkText")}
	</svelte:fragment>
</CareerBanner>
